import {fetch as fetchRaw} from '@lib/fetch'
import {authentication} from '../services'
import {getDefinedUrlSearchParams} from '@lib/util'

const fetch = (url, ...args) => fetchRaw([authentication.url, url], ...args)

export function createApiKeys(body) {
  return fetch(`/v1/api-key`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function listApiKeys(queryParams) {
  return fetch(`/v1/api-key?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export function deleteApiKey(body) {
  return fetch(`/v1/api-key`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}

export function listApiKeysByAdmin(queryParams) {
  return fetch(`/v1/admin/api-key?${getDefinedUrlSearchParams(queryParams)}`, {method: 'GET'})
}

export function createApiKeysByAdmin(body) {
  return fetch(`/v1/admin/api-key`, {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export function deleteApiKeyByAdmin(body) {
  return fetch(`/v1/admin/api-key`, {
    method: 'DELETE',
    body: JSON.stringify(body),
  })
}
